import { Chart, ChartMeta, Plugin } from "chart.js";

const HoverLinePlugin: Plugin = {
  id: 'hoverLine',
  afterDatasetDraw(
    chart: Chart,
    args: { index: number; meta: ChartMeta },
    options: any) {
    const {
      ctx,
      tooltip,
      chartArea: { top, bottom, left, right, width, height },
      scales: { x, y }
    } = chart;

    if (tooltip && (tooltip as any)._active.length > 0 && tooltip.dataPoints) {
      if (tooltip.dataPoints.length > 1) {
        const xFirst = x.getPixelForValue(tooltip.dataPoints[0].parsed.x ?? 0);
        const yFirst = y.getPixelForValue(tooltip.dataPoints[0].parsed.y ?? 0);
        const xSecond = x.getPixelForValue(tooltip.dataPoints[1].parsed.x ?? 0);
        const ySecond = y.getPixelForValue(tooltip.dataPoints[1].parsed.y ?? 0);
        ctx.save();
        try {
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'rgba(191, 213, 255, 0.7)';
          if (yFirst < ySecond) {
            ctx.moveTo(xFirst, yFirst + 6);
            ctx.lineTo(xSecond, ySecond - 6);
          } else {
            ctx.moveTo(xFirst, yFirst - 6);
            ctx.lineTo(xSecond, ySecond + 6);
          }
          ctx.stroke();
          ctx.closePath();
        } finally {
          ctx.restore();
        }
      }
    }
  }
}

export default HoverLinePlugin;